import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "card",
  style: {"margin-bottom":"15px","margin-top":"-25px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Partner Ledger"),
    /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" })
  ])
], -1)
const _hoisted_2 = { class: "badge badge-light-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.accountSourcesRef,
      style: {"width":"100%"},
      height: "550",
      size: "default"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { width: "15" }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "Name",
          width: "200"
        }, {
          default: _withCtx((accountSource) => [
            _createVNode(_component_router_link, { to: { name: 'ledgerDetail', params: { id: '1'}} }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(accountSource.row.name), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "type",
          label: "Type",
          width: "170"
        }, {
          default: _withCtx((accountSource) => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(accountSource.row.type), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "country",
          label: "Country",
          width: "140"
        }),
        _createVNode(_component_el_table_column, {
          prop: "",
          label: "Supported Currencies",
          width: "200"
        }),
        _createVNode(_component_el_table_column, {
          prop: "availableBalance",
          label: "Available Balance",
          width: "250"
        }),
        _createVNode(_component_el_table_column, {
          prop: "unavailableBalance",
          label: "U/A Balance",
          width: "250"
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_el_pagination, {
      currentPage: _ctx.pageNumberRef,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageNumberRef) = $event)),
      "page-size": _ctx.pageSizeRef,
      small: _ctx.small,
      "page-sizes": [20, 30, 40, 50],
      layout: "total,sizes, prev, pager, next",
      total: _ctx.totalRef,
      style: {"float":"right","margin-top":"10px"},
      background: "",
      onSizeChange: _ctx.updatePageSize,
      onCurrentChange: _ctx.updatePageNumber
    }, null, 8, ["currentPage", "page-size", "small", "total", "onSizeChange", "onCurrentChange"])
  ], 64))
}